import { render, staticRenderFns } from "./NotificationDeleteAction.vue?vue&type=template&id=44119376&scoped=true"
import script from "./NotificationDeleteAction.vue?vue&type=script&lang=js"
export * from "./NotificationDeleteAction.vue?vue&type=script&lang=js"
import style0 from "./NotificationDeleteAction.vue?vue&type=style&index=0&id=44119376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44119376",
  null
  
)

export default component.exports